import { mediaCdn } from '../components/Player/Helpers'

/** the site's default picture, for a program or episode with no image */
export const OTT_DEFAULT_IMAGE = {
  desktop: `${mediaCdn}q_auto:best/v1750236296/assets/2025/default.webp`,
  mobile: `${mediaCdn}c_scale,q_auto:best,w_320/v1750236296/assets/2025/default.webp`,
} as const

const SIZE_SUFFIX = /\/width\/\d+[\s\S]*$/

/**
 * A Kaltura OTT image at a given size, or null when there is no image.
 * Any size already on the URL is replaced, not appended to. Building the
 * suffix onto a missing image gave posters like "undefined/width/1920/..."
 * (a request back to the site for a page that does not exist).
 */
export const sizedOttImage = (
  url: string | null | undefined,
  width: number,
  height: number,
  quality?: number
): string | null => {
  const base = (url || '').replace(SIZE_SUFFIX, '')
  if (!/^https?:\/\//.test(base)) {
    return null
  }
  return `${base}/width/${width}/height/${height}${
    quality ? `/quality/${quality}` : ''
  }`
}
